document.addEventListener("DOMContentLoaded", function () {
  // Lazy load images
  const lazyImgs = document.querySelectorAll(".hp-gallery-img.lazy");
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          const img = e.target;
          img.src = img.dataset.src;
          img.classList.remove("lazy");
          observer.unobserve(img);
        }
      });
    }, { rootMargin: "200px" });
    lazyImgs.forEach(img => io.observe(img));
  } else {
    lazyImgs.forEach(img => img.src = img.dataset.src);
  }

  // Lightbox setup
  const gallery = document.querySelector(".hp-gallery-grid");
  if (!gallery) return;

  const enableLightbox = gallery.dataset.lightbox === "true" || gallery.dataset.lightbox === "True";

  function createLightbox() {
    const lb = document.createElement("div");
    lb.id = "hp-lightbox";
    lb.style.cssText = `
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.85);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      z-index: 9999;
    `;
    lb.innerHTML = `
      <button id="hp-lb-close"
        style="position:absolute;top:20px;right:25px;font-size:28px;color:#fff;background:none;border:none;cursor:pointer;">✕</button>
      <img id="hp-lb-img" style="max-width:90%;max-height:80vh;border-radius:10px;object-fit:contain;">
      <p id="hp-lb-caption" style="color:#fff;margin-top:12px;text-align:center;max-width:80%;"></p>
    `;
    document.body.appendChild(lb);
    lb.addEventListener("click", e => {
      if (e.target === lb || e.target.id === "hp-lb-close") lb.remove();
    });
    return lb;
  }

  if (enableLightbox) {
    gallery.querySelectorAll(".hp-gallery-link").forEach(link => {
      link.addEventListener("click", e => {
        e.preventDefault();
        const url = link.getAttribute("href");
        const caption = link.dataset.caption || "";
        const lb = document.getElementById("hp-lightbox") || createLightbox();
        document.getElementById("hp-lb-img").src = url;
        document.getElementById("hp-lb-caption").textContent = caption;
      });
    });
  }

  // 🎬 YouTube video modal
  document.querySelectorAll(".hp-video-item").forEach(item => {
    item.addEventListener("click", () => {
      const videoId = item.dataset.videoId;
      if (!videoId) return;

      const modal = document.createElement("div");
      modal.className = "hp-video-modal";
      modal.style.cssText = `
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.85);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
      `;

      modal.innerHTML = `
        <div class="hp-video-container" style="position:relative;width:80%;max-width:900px;aspect-ratio:16/9;">
          <iframe 
            src="https://www.youtube.com/embed/${videoId}?autoplay=1" 
            allowfullscreen
            frameborder="0"
            style="width:100%;height:100%;border-radius:10px;"
          ></iframe>
          <span class="hp-video-close" style="
            position:absolute;top:-45px;right:0;font-size:34px;color:white;cursor:pointer;
          ">&times;</span>
        </div>
      `;

      document.body.appendChild(modal);

      modal.addEventListener("click", (e) => {
        if (e.target === modal || e.target.classList.contains("hp-video-close")) {
          modal.remove();
        }
      });
    });
  });
});
